export default "__VITE_ASSET__CHevoxaI__"